import { configureStore } from '@reduxjs/toolkit';
import loaderReducer from './loading';

export default configureStore({
  reducer: {
    loader: loaderReducer
  },
})